import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

export interface NavHistoryConfig {
  storageKey: string;
  maxPinned: number;
  maxEntries: number;
}

const NavHistoryConfigContext = createContext<NavHistoryConfig | undefined>(undefined);

export function NavHistoryConfigProvider({
  children,
  storageKey,
  maxPinned = 10,
  maxEntries = 50,
}: {
  children: ReactNode;
  storageKey: string;
  maxPinned?: number;
  maxEntries?: number;
}) {
  const value: NavHistoryConfig = { storageKey, maxPinned, maxEntries };

  return <NavHistoryConfigContext.Provider value={value}>{children}</NavHistoryConfigContext.Provider>;
}

export function useNavHistoryConfig(): NavHistoryConfig {
  const context = useContext(NavHistoryConfigContext);
  if (!context) {
    throw new Error('useNavHistoryConfig must be used within NavHistoryConfigProvider');
  }
  return context;
}
